/**
 * @generated SignedSource<<d15a3b4fb6221805522b095c7578bb54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Inbox_chats$data = {
  readonly myChats: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"InboxChats_chats">;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "Inbox_chats";
};
export type Inbox_chats$key = {
  readonly " $data"?: Inbox_chats$data;
  readonly " $fragmentSpreads": FragmentRefs<"Inbox_chats">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "myChats"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ChatPagePaginationQuery.graphql')
    }
  },
  "name": "Inbox_chats",
  "selections": [
    {
      "alias": "myChats",
      "args": [
        {
          "kind": "Literal",
          "name": "hasMessages",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "-last_message_sent_at"
        }
      ],
      "concreteType": "ChatNodeConnection",
      "kind": "LinkedField",
      "name": "__Inbox_myChats_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ChatNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "InboxChats_chats"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__Inbox_myChats_connection(hasMessages:true,orderBy:\"-last_message_sent_at\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "4a2d050353838c6092f0d78abd33f1bd";

export default node;
